import Head from 'next/head';

type IProps = {
  stock_title: string,
  head_title: string,
  head_author: string,
  head_keywords: string,
  head_desc: string,
  title: string,
  link: string,
  desc: string,
  imgUrl: string,
  children?: any
}

const getTitle = (stock_title: string, head_title: string) => {
  if(stock_title) return `${stock_title}`;
  else if(head_title) return `${head_title}-妙投-专业财经新闻热点资讯`;
  else return '妙投-专业财经新闻热点资讯';
}

const head = (props: IProps) => {
  const { stock_title, head_title, head_author, head_keywords, head_desc, title, link, desc, imgUrl } = props;
  
  return (
    <Head>
      <title>{getTitle(stock_title, head_title)}</title>
      <meta name="author" content={head_author? head_author + '-妙投网' : '妙投网' }/>
      <meta name="keywords" content={`${head_keywords? head_keywords : ''}股票、财经新闻、新经济投资、商业评论、行情政策解读、A股、中概股、港股、美股` }/>
      <meta name="description" content={`${head_desc? head_desc : ''}妙投为虎嗅网旗下，专注于二级市场投资领域的分析和解读，汇聚众多专业投资者，致力于用客观、通俗易懂的方式，帮助用户找到投资过程中的确定性，完成财富与认知的共同增长。` }/>
      <meta name="shareTitle" content={ title ? title : '妙投-专业财经新闻热点资讯' } />
      <meta name="shareLink" content={ link } />
      <meta name="shareDesc" content={desc ? desc : '专注于新经济相关行业、投资标的分析解读，全方位拆解公司的基本面信息，为你提供客观详实的投资参考'} />
      <meta name="shareImgUrl" content={imgUrl ? imgUrl : process.env.NEXT_PUBLIC_API_PRO + '/favicon.ico' } />
      <meta name="google-site-verification" content='p65d1hsZLhPdKrWryEC4gJt1zWQADLpFnp9__p-th1s' />
      <meta name="360-site-verification" content='00f93cf250cb3b3b6aa5f2f1730ed714' />
      <meta name="shenma-site-verification" content='8c01b229ae6730a0cd2a893f14106017_1668394315' />
      <meta name="sogou_site_verification" content='W6aBMY7Tp3' />
      <meta httpEquiv="Content-Type" content='text/html;charset=gb2312' />
      { props.children } 
    </Head>
  )    
}

export default head
